module.exports = __webpack_public_path__ + "static/ahorrar-dinero-aparcar-barcelona-7c6b90b398de54c33e2808226d954d27.svg";